<template>
    <transition name="modal">
        <div class="modal-mask">
            <div class="modal-wrapper" >
                <div class="modal-container" ref="modal" :class="modalSize" v-on-clickaway="away">

                    <div class="modal-header">
                        <slot name="header">
                            default header
                        </slot>
                    </div>

                    <div class="modal-body">
                        <slot name="body">
                            default body
                        </slot>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script type="text/babel">

    import { mixin as clickaway } from 'vue-clickaway';

    export default {
        data() {
            return {
                paymentMethods:[],
                showAddPaymentMethodModal: false,
                modalSize: ''

            }
        },
        created(){

            $('body').addClass('modal-open');
            if(this.size) this.modalSize = 'modal-' + this.size;
            this.$nextTick(function() {
                if(this.size == 'xl'){
                    window.addEventListener('resize', this.getWindowHeight);
                    this.getWindowHeight();
                }
            })
        },
        destroyed(){
            $('body').removeClass('modal-open');
            window.removeEventListener('resize', this.getWindowHeight);
        },
        props:[ 'allowClickAway', 'size' ],
        mixins: [ clickaway ],
        methods: {
            away (){
                this.$emit('close');
            },
            getWindowHeight(){
                this.windowHeight = document.documentElement.clientHeight;

                this.$refs.modal.style.minHeight = (this.windowHeight - 40) + 'px';
            },

        }
    }


</script>

<style>

    .modal-footer {
        padding: 15px 0;
        text-align: right;
        border-top: 1px solid #e5e5e5;
        margin-top: 50px;
    }

    .modal-mask {
        background-color: rgba(0, 0, 0, .5);
        transition: opacity .3s ease;
        overflow: hidden;
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 1050;
        -webkit-overflow-scrolling: touch;
        outline: 0;
    }


    .modal-open {
        overflow: hidden;
    }


    .modal-open .modal-mask {
        overflow-x: hidden;
        overflow-y: auto;
    }



    .modal-container {

        margin: 50px auto;
        padding: 20px 30px;
        background-color: #fff;
        border-radius: 2px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
        transition: all .3s ease;
        font-family: Helvetica, Arial, sans-serif;
        position: relative;
        -webkit-box-shadow: 0 3px 9px rgba(0, 0, 0, 0.5);
        -webkit-background-clip: padding-box;
        background-clip: padding-box;
        outline: 0;


    }

    .modal-header h3 {
        margin-top: 0;
        color: #0288d1;
    }

    .modal-body {
        margin: 20px 0 0 0;
        padding-bottom: 0
    }

    .modal-default-button {
        float: right;
    }

    .modal-enter {
        opacity: 0;
    }

    .modal-leave-active {
        opacity: 0;
    }

    .modal-enter .modal-container,
    .modal-leave-active .modal-container {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }

    .modal-wrapper {
        position: relative;
        width: auto;
        margin: 10px;
    }

    .modal-backdrop {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 1040;
        background-color: #000000;
    }
    .modal-backdrop.fade {
        opacity: 0;
        filter: alpha(opacity=0);
    }
    .modal-backdrop.in {
        opacity: 0.5;
        filter: alpha(opacity=50);
    }

    .modal-scrollbar-measure {
        position: absolute;
        top: -9999px;
        width: 50px;
        height: 50px;
        overflow: scroll;
    }

    .modal-container.modal-xl {
        width: 100%;
    }

    @media (min-width: 768px) {
        .modal-container {
            width: 600px;
            margin: 30px auto;
        }
        .modal-content {
            -webkit-box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5);
            box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5);
        }
        .modal-sm {
            width: 300px;
        }
    }
    @media (min-width: 992px) {
        .modal-lg {
            width: 800px;
        }
    }



    .clearfix:before,
    .clearfix:after,
    .modal-header:before,
    .modal-header:after,
    .modal-footer:before,
    .modal-footer:after {
        content: " ";
        display: table;
    }
    .clearfix:after,
    .modal-header:after,
    .modal-footer:after {
        clear: both;
    }



</style>



// WEBPACK FOOTER //
// Modal.vue?3614158c